import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { ProductType } from '@barboxx/models';

const COLUMNS: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'name', headerName: 'Name', width: 200 },
    {
        field: 'category.name',
        headerName: 'Category',
        width: 200,
        sortable: false,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'description',
        headerName: 'Description',
        width: 200,
        flex: 1,
        sortable: false,
    },
    {
        field: 'isAlcoholic',
        headerName: 'Is Alcoholic',
        width: 200,
        type: 'boolean',
    },
];

interface Props {
    data: ProductType[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function ProductTypeTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Alcohol Types">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
